/**
 * Link
 * A wrapper component that handles different types of links for the client and the CMS.
 * @module common/Link
 */

import React, { Component } from 'react';
import { withRouter } from 'next/router';
import { Link as NextLink } from 'common/routes';
import nextConfig from 'common/config';


class Link extends Component {

	/**
	 * Compose a URL that can be used when visiting through the CMS.
	 */
	getPreviewUrl() {
		let { href, route } = this.props;
		href = href && href.pathname ? href.pathname : href;
		let url = route ? route : href;
		return url.indexOf('http') === -1 ? nextConfig.adminUrl + url : url;
	}


	render() {
		const { children, router, external } = this.props;
		const childrenWithoutAnchor = children.type === 'a' ? children.props.children : children;
		const anchorClasses = children.type === 'a' && children.props.className ? children.props.className : null;
		const nextLinkProps = { ...this.props };
		delete nextLinkProps.router;
		delete nextLinkProps.external;

		return router.asPath.indexOf('_preview') !== -1  ? (
			<a href={this.getPreviewUrl()} className={anchorClasses} target="_parent">
				{childrenWithoutAnchor}
			</a>
		) : (router.asPath.indexOf('_preview') === -1 && external) ? (
			<a {...nextLinkProps}>{children}</a>
		) : (
			<NextLink {...nextLinkProps}>{children}</NextLink>
		);
	}
}


export default withRouter(Link);
